import { Helmet } from "react-helmet-async";

const SITE = "https://thewheretogo.com";
const DEFAULT_OG = "https://customer-assets.emergentagent.com/job_suspicious-visvesvaraya-7/artifacts/cjbz0mfo_WhatsApp%20Image%202025-07-04%20at%2023.11.02_ca176646%20SQ.jpg";

export default function Seo({ title, description, image = DEFAULT_OG, path = "", type = "website", article }) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} — The Where To Go` : "The Where To Go — Documentary Travel";
  const desc = description || "Documentary travel writing — long-form guides, downloadable PDFs and films from across the world.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc}/>
      <link rel="canonical" href={url}/>

      <meta property="og:type" content={type}/>
      <meta property="og:site_name" content="The Where To Go"/>
      <meta property="og:title" content={fullTitle}/>
      <meta property="og:description" content={desc}/>
      <meta property="og:url" content={url}/>
      <meta property="og:image" content={image}/>

      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={fullTitle}/>
      <meta name="twitter:description" content={desc}/>
      <meta name="twitter:image" content={image}/>

      {article && (
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TravelArticle",
          "headline": article.title,
          "description": article.excerpt,
          "image": [image],
          "datePublished": article.published,
          "author": { "@type": "Organization", "name": "The Where To Go" },
          "publisher": {
            "@type": "Organization",
            "name": "The Where To Go",
            "logo": { "@type": "ImageObject", "url": DEFAULT_OG }
          },
          "about": article.destination,
          "url": url,
        })}</script>
      )}
    </Helmet>
  );
}
